import React from 'react';
import { Box } from '@mui/material';
import Grid, { GridProps } from '@mui/material/Grid';
import styled from 'styled-components';
import { colors } from 'spw-theme';

export const ChartTitle = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 12px;
  line-height: 12px;
  letter-spacing: 1.2px;
  color: ${colors.mainGray};
  text-transform: uppercase;
  width: 100%;
  margin-bottom: 16px;
`;

export const ChartColumn = styled.div`
  && {
    font-family: Roboto;
    font-style: normal;
    font-size: 12px;
    font-weight: normal;
    line-height: 16px;
    letter-spacing: 0.25px;

    &.right {
      text-align: right;
    }

    &.percent {
      width: 48px;
    }

    &.bubble-column {
      align-items: center;
      display: flex;
      justify-content: flex-start;
    }
  }
`;

export const PercentColumn = styled(ChartColumn)`
  display: flex;
  justify-content: flex-end;
`;

export const ChartSummaryPill = styled.div`
  && {
    margin: 0px -5px;
    padding: 0px 5px;
    width: 100%;

    &:hover {
      &.highlight {
        border-radius: 11px;
        background: #eeeeee;
        cursor: pointer;
      }
    }
  }
`;

export const ChartSummaryHeaderRow = styled((props: GridProps) => (
  <Grid container {...props} />
))`
  && {
    display: flex;
    align-items: flex-end;
    border-bottom: 1px solid #e0e0e0;
    height: 20px;
  }
`;

export const ChartSummaryHeader = styled(ChartColumn)`
  && {
    color: #4a4a4a;
    white-space: nowrap;
    padding-bottom: 4px;
  }
`;

export const ChartContainer = styled((props: GridProps) => (
  <Grid item {...props} />
))`
  && {
    margin-top: 8px;
  }
`;

export const SpaceDataRowContainer = styled((props: GridProps) => (
  <Grid container {...props} />
))`
  && {
    align-items: center;
    margin-top: 8px;
    height: 18px;
    padding-left: 4px;

    &:hover {
      &.highlight {
        border-radius: 11px;
        background: #eeeeee;
        cursor: pointer;
      }
    }
  }
`;

export const SpaceNamesContainer = styled((props: GridProps) => (
  <Grid container {...props} />
))`
  && {
    padding-left: 4px;
    margin-top: 16px;
  }
`;

export const SpaceNameRow = styled((props: GridProps) => (
  <Grid item {...props} />
))`
  && {
    margin-bottom: 7px;
  }
`;

export const SmallBubbleIcon = styled.div`
  && {
    width: 12px;
    height: 12px;
    border-radius: 9px;
    background-color: ${(props) => props.color} !important;
  }
`;

export const SpaceCategoryName = styled(Box)`
  && {
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 12px;
    letter-spacing: 0.25px;
    text-transform: capitalize;
    color: #4a4a4a;
    text-align: left;
    padding-left: 4px;
    text-overflow: ellipsis;
    overflow: hidden;
    white-space: nowrap;
    margin-right: 16px;
  }
`;

export const DisclaimerTextContainer = styled.div`
  && {
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    align-self: flex-end;
    font-family: Roboto;
    font-style: normal;
    font-weight: normal;
    font-size: 10px;
    line-height: 16px;
    letter-spacing: 0.25px;
    text-align: right;
    flex-grow: 1;
    color: #4a4a4a;
  }
`;

export const ControlledLineBreaks = styled.div`
  && {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: flex-end;
  }
`;

export const Pill = styled.div`
  && {
    background-color: ${(props) => (props.color ? props.color : '#eeeeee')};
    width: 34px;
    height: 16px;
    border-radius: 11px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-family: Roboto;
    font-size: 12px;
    font-weight: normal;
  }
`;

export const SmallDonutChartCard = styled(Grid)`
  && {
    box-sizing: border-box;
    height: 181px;
    display: flex;
    flex-direction: column;
    background: ${colors.white};
    border: 1px solid ${colors.veryLightGray};
    border-radius: 8px;
    padding: 16px;
  }
`;

export const SpaceNameListRow = styled((props: GridProps) => (
  <Grid container {...props} />
))`
  && {
    &.first {
      margin-top: 15px;
    }

    margin-top: 8px;
  }
`;
